import React, { useState } from "react"
import "./styles.scss"
import { SendEvents } from "../analytics/analyticsEvents"
import { isMobile } from "react-device-detect"

export const onPhoneClick = async (id, e, setShowNumber) => {
  if (!isMobile) {
    e.preventDefault()
    setShowNumber(true)
  }
  SendEvents({
    eventName: "phone/click",
    data: {
      value: 1,
      id,
    },
  })
}

const PhoneNumber = ({ id }) => {
  const [showNumber, setShowNumber] = useState(false)

  return (
    <a
      className={"phone-number"}
      id={id}
      href="tel:+1 (647) 459-9664"
      onClick={e => onPhoneClick(id, e, setShowNumber)}
    >
      {showNumber ? "+1 (647) 459-9664" : "Call us today!"}
    </a>
  )
}

export default PhoneNumber
